import React from 'react';
import B2BTable from './B2BTable';

const B2BTableInMemory = ({
    rows,
    onRowClick,
    numRows = 5,
    ...rest
}) => {

    const [page, setPage] = React.useState(1);
    const [rowsPerPage] = React.useState(numRows);
    const [rowsToDisplay, setRowsToDisplay] = React.useState([]);
    const [totalRows, setTotalRows] = React.useState(rows.length);
    const [totalPages, setTotalPages] = React.useState(Math.ceil(totalRows / rowsPerPage));

    React.useEffect(() => {
        setTotalRows(rows.length);
        setRowsToDisplay(rows.slice((page - 1) * rowsPerPage, (page - 1) * rowsPerPage + rowsPerPage));
        setTotalPages(Math.ceil(rows.length / rowsPerPage));
    }, [page, rows, rowsPerPage]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleRowClick = (row) => {
        if (onRowClick)
            onRowClick(row);
    };

    //console.log('B2BTableInMemory is being rendered', rows);

    return (
        <B2BTable
            rows={rowsToDisplay}
            pagesCount={totalPages}
            currentPage={page}
            onPageChange={handleChangePage}
            onRowClick={handleRowClick}
            {...rest}
        />
    );
};

export default B2BTableInMemory;